/**
 * authClient - An interface to api client to handle authenication.
 * @module api/authClient
 * @see module:api/authClient
 */
import client from '../client';

export default {
    /**
     * login
     * @param {} data
     */
    login(credentials) {
        return client.post('auth/login', credentials);
    },
};
